import { Link } from "react-router-dom";
import { TRAEmptyState } from "../../../../design";
import styles from "../../styles/playerEcosystem.module.css";

/**
 * Chronological activity feed for Player Intelligence.
 */
export default function ActivityTimelineFeed({ events, emptyCopy }) {
  if (!events?.length) {
    return (
      <TRAEmptyState
        title={emptyCopy?.title || "No matches yet"}
        description={
          emptyCopy?.body || "Play a match — your journey timeline starts here."
        }
        action={
          emptyCopy?.ctaTo ? (
            <Link to={emptyCopy.ctaTo} className={styles.emptyCta}>
              {emptyCopy.ctaLabel || "Start an Arena"}
            </Link>
          ) : null
        }
      />
    );
  }
  return (
    <ol className={styles.activityFeed} aria-label="Match timeline">
      {events.map((e) => (
        <li key={e.id} className={`${styles.activityItem} ${styles[`tone_${e.tone}`] || ""}`}>
          <div className={styles.activityDot} aria-hidden />
          <div className={styles.activityBody}>
            <p className={styles.activityTitle}>{e.title}</p>
            {e.detail ? <p className={styles.activityDetail}>{e.detail}</p> : null}
            {e.whenLabel ? <p className={styles.activityWhen}>{e.whenLabel}</p> : null}
          </div>
        </li>
      ))}
    </ol>
  );
}
